import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 0 3rem;
  background: "#F5F5F5";
  @media screen and (max-width: 500px) {
    padding: 0;
  }
`;

export const TabBar = styled.div`
  max-width: 1040px;
  height: 70px;
  margin: 0 auto;
  display: flex;
  align-items: flex-end;
  justify-content: start;
`;

export const TabToggle = styled.button`
  background: transparent;
  border: none;
  width: 200px;
  height: 50px;
  border-radius: 10px 10px 0 0;
  padding: 0 5px;

  font-weight: bold;
  font-size: 15px;

  @media screen and (max-width: 500px) {
    width: 100%;
  }
  ${({ selected }) =>
    selected
      ? css`
          color: #fff;
          background: #071242;
        `
      : css`
          color: #071242;
        `}
`;
